export default "__VITE_ASSET__DxcOS$pF__"